import { useCallback, useMemo, useState } from 'react';

export const useTinyMCEAction = () => {
  const [promiseResolver, setPromiseResolver] = useState<() => void>();

  const init = useCallback(
    () =>
      new Promise<void>(resolve => {
        finish();
        setPromiseResolver(() => resolve);
      }),
    []
  );

  const finish = useCallback(() => {
    setPromiseResolver(old => {
      old?.();
      return undefined;
    });
  }, []);

  const running = useMemo(() => !!promiseResolver, [promiseResolver]);

  return {
    init,
    finish,
    running: running
  };
};
